
export const TOGGLE_OPTION_HIDDEN = 'TOGGLE_OPTION_HIDDEN';
export function toggleOptionHidden(option, section, responseID) {
  if(!responseID){
    throw new Error("toggleOptionHidden called without responseID argument")
  }
  return{
    type: TOGGLE_OPTION_HIDDEN,
    option,
    section,
    responseID
  }
}

export const SORT_OPTIONS = "SORT_OPTIONS"
export function saveUserSort(optionIDs, section, filter, responseID){
  if(!responseID){
    throw new Error("sortOptions called without response argument")
  }
  return{
    type: SORT_OPTIONS,
    optionIDs: optionIDs,
    section: section,
    filter: filter,
    responseID
  }
}

export const SAVE_NOTE = "SAVE_NOTE"
export function saveNote(optionID, notes, responseID){
  if (!responseID){
    throw new Error("saveNote called without responseID argument")
  }
  return{
    type: SAVE_NOTE,
    optionID: optionID,
    notes: notes,
    responseID
  }
}

export const DELETE_NOTE = "DELETE_NOTE"
export function deleteNote(optionID, responseID){
  if(!responseID){
    throw new Error("deleteNote called without responseID argument")
  }
  return{
    type: DELETE_NOTE,
    optionID: optionID,
    responseID
  }
}

export const BULK_TOGGLE_OPTIONS_HIDDEN = 'BULK_TOGGLE_OPTIONS_HIDDEN';
export const bulkToggleOptionsHidden = (ids, section, responseID) => {
  return {
    type: BULK_TOGGLE_OPTIONS_HIDDEN,
    ids,
    section,
    responseID
  }
}

export const TOGGLE_STAR = 'TOGGLE_STAR';
export const toggleStar = (option, section, responseID) => {
  return {
    type: TOGGLE_STAR,
    option: option,
    section,
    responseID
  }
}

export const UPDATE_REVIEW_STAGE = 'UPDATE_REVIEW_STAGE';
export const updateReviewStage = (stage, section, responseID) => {
  return {
    type: UPDATE_REVIEW_STAGE,
    section,
    stage,
    responseID
  }
}